import React, { useEffect } from 'react';

const QrRedirection = () => {
    useEffect(()=>{
        const userAgent = navigator.userAgent.toLowerCase();

        let link = "https://www.evidentdigital.com";
        if (userAgent.includes("android")) {
            link = "https://play.google.com/store/apps/details?id=com.evidentdigital.evident";
        } else if (/ipad|iphone|ipod/.test(userAgent)) {
            link = "https://apps.apple.com/app/evismart-app/id6737177426";
        }

        window.location.href = link;

    },[]);
    return (
        <></>
    )
};

export default QrRedirection